// Mock data pour Webysee.fr

export const services = [
  {
    id: 1,
    title: "Création de sites web",
    description: "Sites vitrines, e-commerce, applications web sur-mesure",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Design UX/UI",
    description: "Interfaces élégantes, ergonomiques et centrées utilisateur",
    icon: "Palette"
  },
  {
    id: 3,
    title: "SEO & Performance",
    description: "Référencement naturel et optimisation des performances",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Maintenance & Support",
    description: "Accompagnement continu et support technique réactif",
    icon: "Shield"
  },
  {
    id: 5,
    title: "Marketing Digital",
    description: "Stratégies publicitaires, community management, branding",
    icon: "Megaphone"
  },
  {
    id: 6,
    title: "Solutions IA",
    description: "Intégration d'intelligence artificielle et automatisation",
    icon: "Sparkles"
  }
];

export const whyUs = [
  {
    id: 1,
    title: "Approche sur-mesure",
    description: "Chaque projet est unique, nous adaptons nos solutions à vos besoins spécifiques."
  },
  {
    id: 2,
    title: "Design premium",
    description: "Des interfaces élégantes qui reflètent l'excellence de votre marque."
  },
  {
    id: 3,
    title: "Technologie moderne",
    description: "Les dernières technologies pour des sites performants et évolutifs."
  },
  {
    id: 4,
    title: "Accompagnement humain",
    description: "Une équipe dédiée à votre écoute, du brief à la mise en ligne."
  },
  {
    id: 5,
    title: "Résultats concrets",
    description: "Des sites qui convertissent et génèrent de la valeur pour votre entreprise."
  }
];

export const offers = [
  {
    id: 1,
    title: "Projets simples",
    description: "Sites vitrines, landing pages, portfolios. Solutions rapides et efficaces pour lancer votre présence en ligne.",
    features: ["Site vitrine responsive", "Design personnalisé", "Optimisation SEO de base", "Formation à l'utilisation"],
    highlight: false
  },
  {
    id: 2,
    title: "Projets complexes",
    description: "E-commerce, applications web, plateformes sur-mesure. Solutions avancées pour des besoins spécifiques.",
    features: ["Architecture sur-mesure", "Fonctionnalités avancées", "Intégrations tierces", "Support prioritaire"],
    highlight: true
  },
  {
    id: 3,
    title: "Solutions personnalisées",
    description: "Projets uniques nécessitant une approche totalement adaptée à vos enjeux business.",
    features: ["Audit complet", "Stratégie digitale", "Développement agile", "Accompagnement continu"],
    highlight: false
  }
];

export const contactInfo = {
  phone: "06 23 88 08 81",
  email: "contact@webysee.com",
  address: "France"
};

export const navLinks = [
  { id: 1, label: "Accueil", href: "#hero" },
  { id: 2, label: "Expertise", href: "#expertise" },
  { id: 3, label: "Réalisations", href: "#portfolio" },
  { id: 4, label: "Témoignages", href: "#testimonials" },
  { id: 5, label: "Blog", href: "/blog", isRoute: true },
  { id: 6, label: "Contact", href: "#contact" }
];

// Portfolio Projects Data
export const portfolioProjects = [
  {
    id: 1,
    title: "LuxeMode",
    subtitle: "Boutique de mode haut de gamme",
    category: "e-commerce",
    image: "https://images.pexels.com/photos/8534380/pexels-photo-8534380.jpeg",
    imageAfter: "https://images.pexels.com/photos/12882904/pexels-photo-12882904.jpeg",
    description: "Création d'une boutique en ligne premium pour une marque de prêt-à-porter de luxe. Design épuré, expérience d'achat immersive et intégration complète avec leur système de gestion des stocks.",
    client: "LuxeMode Paris",
    year: "2024",
    duration: "3 mois",
    technologies: ["React", "Node.js", "Stripe", "Shopify API"],
    results: {
      traffic: "+245%",
      conversion: "+180%",
      revenue: "+320%"
    },
    testimonial: {
      text: "Webysee a transformé notre présence en ligne. Les ventes ont explosé dès le premier mois !",
      author: "Marie Dubois",
      role: "Directrice Marketing"
    },
    link: "#"
  },
  {
    id: 2,
    title: "TechVision",
    subtitle: "Startup Intelligence Artificielle",
    category: "site-vitrine",
    image: "https://images.pexels.com/photos/16023919/pexels-photo-16023919.jpeg",
    imageAfter: "https://images.pexels.com/photos/8217409/pexels-photo-8217409.jpeg",
    description: "Site vitrine moderne pour une startup spécialisée en IA. Animations fluides, présentation des solutions technologiques et tunnel de génération de leads B2B.",
    client: "TechVision AI",
    year: "2024",
    duration: "6 semaines",
    technologies: ["Next.js", "Three.js", "Framer Motion", "HubSpot"],
    results: {
      traffic: "+180%",
      conversion: "+95%",
      leads: "+150%"
    },
    testimonial: {
      text: "Un site qui reflète parfaitement notre ADN innovant. L'équipe a su comprendre nos enjeux.",
      author: "Thomas Martin",
      role: "CEO & Fondateur"
    },
    link: "#"
  },
  {
    id: 3,
    title: "GreenFood",
    subtitle: "Livraison de repas bio",
    category: "application",
    image: "https://images.pexels.com/photos/6203792/pexels-photo-6203792.jpeg",
    imageAfter: "https://images.pexels.com/photos/6612376/pexels-photo-6612376.jpeg",
    description: "Application web progressive pour un service de livraison de repas bio. Interface intuitive, système de commande en temps réel et suivi de livraison.",
    client: "GreenFood",
    year: "2024",
    duration: "4 mois",
    technologies: ["React", "Node.js", "MongoDB", "Socket.io", "PWA"],
    results: {
      traffic: "+320%",
      conversion: "+210%",
      orders: "+450%"
    },
    testimonial: {
      text: "L'application a révolutionné notre business. Nos clients adorent l'expérience utilisateur !",
      author: "Sophie Leroy",
      role: "Co-fondatrice"
    },
    link: "#"
  },
  {
    id: 4,
    title: "ArchiDesign",
    subtitle: "Cabinet d'architecture",
    category: "site-vitrine",
    image: "https://images.pexels.com/photos/8947493/pexels-photo-8947493.jpeg",
    imageAfter: "https://images.pexels.com/photos/1111367/pexels-photo-1111367.jpeg",
    description: "Portfolio élégant pour un cabinet d'architecture renommé. Galerie de projets immersive, navigation fluide et intégration 3D des réalisations.",
    client: "ArchiDesign Studio",
    year: "2023",
    duration: "2 mois",
    technologies: ["Vue.js", "GSAP", "Sanity CMS", "Cloudinary"],
    results: {
      traffic: "+190%",
      conversion: "+120%",
      inquiries: "+200%"
    },
    testimonial: {
      text: "Notre nouveau site est devenu notre meilleur commercial. Les demandes de devis ont doublé.",
      author: "Pierre Durand",
      role: "Architecte Principal"
    },
    link: "#"
  },
  {
    id: 5,
    title: "FitnessPro",
    subtitle: "Plateforme de coaching",
    category: "application",
    image: "https://images.pexels.com/photos/12882904/pexels-photo-12882904.jpeg",
    imageAfter: "https://images.pexels.com/photos/8534380/pexels-photo-8534380.jpeg",
    description: "Plateforme complète de coaching fitness en ligne. Espace membres, vidéos à la demande, suivi des performances et système d'abonnement.",
    client: "FitnessPro Academy",
    year: "2024",
    duration: "5 mois",
    technologies: ["React", "Python", "PostgreSQL", "AWS", "Stripe"],
    results: {
      traffic: "+280%",
      conversion: "+165%",
      subscribers: "+380%"
    },
    testimonial: {
      text: "La plateforme nous a permis de passer de 50 à 500 abonnés en 6 mois. Incroyable !",
      author: "Julie Bernard",
      role: "Coach & Fondatrice"
    },
    link: "#"
  },
  {
    id: 6,
    title: "VinoDomaine",
    subtitle: "Domaine viticole premium",
    category: "e-commerce",
    image: "https://images.pexels.com/photos/8217409/pexels-photo-8217409.jpeg",
    imageAfter: "https://images.pexels.com/photos/6203792/pexels-photo-6203792.jpeg",
    description: "Boutique en ligne pour un domaine viticole de prestige. Expérience de dégustation virtuelle, gestion des millésimes et expédition internationale.",
    client: "Domaine de la Vallée",
    year: "2023",
    duration: "3 mois",
    technologies: ["Shopify", "Liquid", "JavaScript", "Klaviyo"],
    results: {
      traffic: "+210%",
      conversion: "+145%",
      international: "+400%"
    },
    testimonial: {
      text: "Nos ventes à l'export ont quadruplé grâce au nouveau site. Un investissement rentabilisé en 3 mois.",
      author: "François Moreau",
      role: "Propriétaire"
    },
    link: "#"
  }
];

export const portfolioCategories = [
  { id: "all", label: "Tous les projets" },
  { id: "e-commerce", label: "E-commerce" },
  { id: "site-vitrine", label: "Sites vitrines" },
  { id: "application", label: "Applications" }
];

// Testimonials Data
export const testimonials = [
  {
    id: 1,
    name: "Marc Dubois",
    role: "CEO",
    company: "TechStart SAS",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face",
    rating: 5,
    text: "Webysee a transformé notre vision en réalité. Leur équipe a su comprendre nos besoins et livrer un site qui dépasse nos attentes. Le trafic a augmenté de 200% en 3 mois !",
    project: "Site vitrine",
    results: "+200% trafic",
    featured: true
  },
  {
    id: 2,
    name: "Sophie Martin",
    role: "Directrice Marketing",
    company: "ModeBoutique",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
    rating: 5,
    text: "Un travail exceptionnel ! Notre boutique en ligne est magnifique et les ventes ont explosé. L'équipe est réactive, professionnelle et vraiment à l'écoute.",
    project: "E-commerce",
    results: "+350% ventes",
    featured: true
  },
  {
    id: 3,
    name: "Thomas Bernard",
    role: "Fondateur",
    company: "GreenFood",
    image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=400&h=400&fit=crop&crop=face",
    rating: 5,
    text: "L'application développée par Webysee a révolutionné notre service de livraison. Interface intuitive, performances au top. Je recommande à 100% !",
    project: "Application web",
    results: "+450% commandes",
    featured: false
  },
  {
    id: 4,
    name: "Julie Leroy",
    role: "Architecte",
    company: "ArchiDesign Studio",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop&crop=face",
    rating: 5,
    text: "Notre portfolio en ligne est devenu notre meilleur commercial. Les clients sont impressionnés dès leur première visite. Un investissement rentabilisé en quelques semaines.",
    project: "Portfolio",
    results: "+180% demandes",
    featured: true
  },
  {
    id: 5,
    name: "Antoine Moreau",
    role: "Gérant",
    company: "Domaine de la Vallée",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
    rating: 5,
    text: "Grâce à Webysee, nos ventes à l'international ont quadruplé. Le site est élégant, rapide et parfaitement adapté à notre image de marque premium.",
    project: "E-commerce",
    results: "+400% export",
    featured: false
  },
  {
    id: 6,
    name: "Claire Petit",
    role: "Coach Fitness",
    company: "FitnessPro Academy",
    image: "https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=400&h=400&fit=crop&crop=face",
    rating: 5,
    text: "La plateforme de coaching en ligne créée par Webysee m'a permis de passer de 50 à 500 abonnés en 6 mois. Un travail remarquable !",
    project: "Plateforme",
    results: "+900% abonnés",
    featured: false
  }
];
